import React, { useState, useEffect, useRef, Fragment } from "react";
import { Box, Button, Typography, tooltipClasses, useMediaQuery } from "@mui/material";
import { Thing } from "../../../interfaces/course";
import { removeDomainFromUrl, createProductTypeUrl } from "../../../helpers/utils";
import { BorderLinearProgress } from "../../playlist/accoridonStyles";
import styles from "./trainingCard.module.css";
import "./trainingCard.scss";
import { clickCourseButton } from "../../mixPanelEvents/mixPanelEvents";
import { WhiteLockIcon, PaddockIcon, PlayIcon } from "./icons";
import PlayCircleFilledOutlinedIcon from "@mui/icons-material/PlayCircleFilledOutlined";
import { TooltipCustom } from "../../tooltip/TooltipCustom";
import { Xclose } from "./icons";
import { orderByDocument, useAccelerators } from "../../../hooks/useAccelerators";
import { ProductType } from "./trainingCardCarousel";
import Indicators from "./indicators/indicators";

interface ClickCourseButtonParams {
  source: string;
  carouselTitle: string;
  status: string;
  courseName: string;
  location: string;
  hasCpPopup?: boolean;
  withTimeout?: boolean;
}

interface TrainingCardProps {
  accelerator: Thing;
  carouselTitle: string;
  cardWidth: string;
  locationValue: string;
  hoverPointer?: boolean;
  source?: string;
  initialHover?: boolean;
  leftHoverPointer?: boolean;
  isSidebarOpen?: boolean;
}

const previouslyHoveredVideo = { current: null as HTMLVideoElement | null };

const isIOS = () => {
  const ua = navigator.userAgent;
  // legacy iOS (iPhone/iPad/iPod)
  if ( /iPad|iPhone|iPod/.test(ua) && !(window as any).MSStream ) {
    return true;
  }
  // iPadOS 13+ Safari detection
  if (/\bMacintosh\b/.test(ua) && navigator.maxTouchPoints > 1) {
    return true;
  }
  return false;
};



const handleSendClickCourseButtonMixPanelEvent = ({
  source,
  carouselTitle,
  status,
  courseName,
  location,
  hasCpPopup,
  withTimeout = false
}: ClickCourseButtonParams) => {
  if (withTimeout) {
    setTimeout(() => {
      clickCourseButton(source, carouselTitle, status, courseName, location, hasCpPopup);
    }, 1000);
  } else {
    clickCourseButton(source, carouselTitle, status, courseName, location, hasCpPopup);
  }
};

export default function TrainingCard({
  accelerator,
  carouselTitle,
  cardWidth,
  locationValue,
  hoverPointer,
  source,
  initialHover = false,
  leftHoverPointer,
  isSidebarOpen
}: TrainingCardProps) {

  const [isHovered, setIsHovered] = useState(initialHover);
  const [isClicked, setIsClicked] = useState(false);
  const [isVideoMutted, setIsVideoMutted] = useState(true);
  const videoRef = useRef<HTMLVideoElement>(null);
  const wrapperRef = useRef<HTMLDivElement>(null);
  const cardHolderRef = useRef<HTMLDivElement>(null);
  const isSmallScreen = useMediaQuery('(max-width:768px)');
  const isMobile = useMediaQuery('(max-width:768px)');
  const [isHoverdUnlockButton, setIsHoverdUnlockButton] = useState(false)
  let buttonisClicked = false;
  const [isMostPopularSplitEnabled, setisMostPopularSplitEnabled] = useState(false)
  const isProductType = carouselTitle === ProductType["Training Aids"] ||
    carouselTitle === ProductType.Clubs;
  const touchStartPos = useRef<{ x: number; y: number } | null>(null);

  useEffect(() => {
    console.log(window.location.pathname, "TEST")
    if (window.location.pathname !== "/scratch-club" && window.location.pathname !== "/scratch-club/") {
      // @ts-ignore
      setisMostPopularSplitEnabled(window.netflixCourseButtonsSplit ? true : false)
    }
  }, [window.location.pathname])

  const navigateToPage = (url: string) => {
    const isProductType = carouselTitle === ProductType["Training Aids"] ||
      carouselTitle === ProductType.Clubs;

    if (isProductType) {
      window.open(createProductTypeUrl(accelerator.url), '_blank', 'noopener,noreferrer');
    } else {
      window.location.href = url;
    }
  };



  const getBackgroundStyle = (courseTitle: string) => {
    if (courseTitle === ProductType['Training Aids'] || courseTitle === ProductType.Clubs) {
      return {
        background: 'linear-gradient(180deg, #FFF 0.03%, #999 129.61%)'
      };
    }
    return {};
  };

  const hasPurchasedTrue = accelerator.filters.some((filter) => filter === "purchased:true");
  const hasPurchasedFalse = accelerator.filters.some((filter) => filter === "purchased:false");

  let purchased: boolean | undefined;
  if (hasPurchasedFalse) {
    purchased = false;
  } else if (hasPurchasedTrue) {
    purchased = true;
  } else if(accelerator.hasOwnProperty("is_sc_member") && accelerator.is_sc_member == false) {
    purchased = false;
    accelerator.has_access = false;
    accelerator.oneClickUrl = 'purchase SC';
    accelerator.url = '/scratch-club-benefits/';
  } else {
    purchased = true;
  }

  function openPopUp(event: any, hasAccess: boolean, url: any, courseName: any, cta: any, oneClickUrl: string) {
    event.preventDefault();

    const hasChamp = window.pgUser?.products?.some((product: string) => product === '125' || product === '124')
    const isProductType = carouselTitle === ProductType["Training Aids"] ||
      carouselTitle === ProductType.Clubs;

    if (!hasChamp && hasAccess && window.championsPassModalLockedABTest) {
      var redirectUrl = url;
      if (oneClickUrl !== '') {
        redirectUrl = oneClickUrl;
      }
      window.showChampionsPassPopupNoTimeout(redirectUrl, courseName, cta);
    }
    else if (oneClickUrl !== '') {
      if(oneClickUrl == 'purchase SC') {
        window.location.href = accelerator.url;
      }
      else if (isProductType) {
        window.open(createProductTypeUrl(accelerator.url), '_blank', 'noopener,noreferrer');
      } else {
        window.location.href = removeDomainFromUrl(oneClickUrl);
      }
    } else {
      if (isProductType) {
        window.open(createProductTypeUrl(accelerator.url), '_blank', 'noopener,noreferrer');
      } else {
        window.location.href = removeDomainFromUrl(accelerator.url);
      }
    }
  }

  const coverVideoUrl = accelerator.cover_video;

  useEffect(() => {
    const videoElement = videoRef.current;

    if (isHovered && videoElement) {
      videoElement.play().catch((error) => console.log("Autoplay failed:", error));
      if (previouslyHoveredVideo.current && previouslyHoveredVideo.current !== videoElement) {
        previouslyHoveredVideo.current.pause();
      }
      previouslyHoveredVideo.current = videoElement;
    } else if (videoElement) {
      videoElement.pause();
    }
  }, [isHovered]);

  const handleVideoClick = () => {
    const videoElement = videoRef.current;
    if (isIOS()) {
      return;
    }
    if (videoElement) {
      videoElement.muted = !videoElement.muted;
      setIsVideoMutted(videoElement.muted);
      setIsClicked(true);
      if (!videoElement.muted) {
        videoElement.play().catch((error) => console.log("Play failed:", error));
      }
    }
  };

  const handleClickOutside = (event: MouseEvent | TouchEvent) => {
    const target = event.target as HTMLElement;
    if (target.closest('.pg-popup') || target.closest('[role="presentation"]')) {
      return;
    }
    if (cardHolderRef.current && !cardHolderRef.current.contains(event.target as Node)) {
      setIsHovered(false);
    }
  };

  useEffect(() => {
    if (isHovered) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    function onTouchStart(e: TouchEvent) {
      const touch = e.touches[0];
      touchStartPos.current = { x: touch.clientX, y: touch.clientY };
    }
    function onTouchMove() {
      if (!touchStartPos.current) return;
      touchStartPos.current = null;
    }
    function onTouchEnd(e: TouchEvent) {
      const start = touchStartPos.current;
      touchStartPos.current = null;
      if (start) {
        handleClickOutside(e);
      }
    }
    if(isIOS()) {   
      document.addEventListener("touchstart", onTouchStart, { passive: true });
      document.addEventListener("touchmove", onTouchMove, { passive: true });
      document.addEventListener("touchend", onTouchEnd);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);

      if(isIOS()) {
        document.removeEventListener("touchstart", onTouchStart);
        document.removeEventListener("touchmove", onTouchMove);
        document.removeEventListener("touchend", onTouchEnd);
      }
    };
  }, [isHovered]);

  useEffect(() => {
    const handleDocumentClick = (event: MouseEvent) => {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target as Node)) {
        setIsHovered(false);
      }
    };

    if (isClicked) {
      document.addEventListener("mousedown", handleDocumentClick);
    } else {
      document.removeEventListener("mousedown", handleDocumentClick);
    }

    return () => {
      document.removeEventListener("mousedown", handleDocumentClick);
    };
  }, [isClicked]);

  const checkScratchClubAccessFromScCatalog = () => {
    if (typeof window !== 'undefined' && window.pgUser?.products) {
      return window.pgUser.products.some((product: string) => product === '1' || product === 'Scratch Club'); // Scratch Club product ID
    }
    return false;
  };

  return (
    <div
    ref={cardHolderRef}
    onClickCapture={(event) => {
      console.log("clicked")
      if (!checkScratchClubAccessFromScCatalog() && window.location.pathname === '/scratch-club') {
        event.stopPropagation(); // Stop event from bubbling to child elements
        event.preventDefault();  // Prevent default action
        window.location.href = '/scratch-club-benefits/';
        return false; 
      }
      return true;
    }}
className={`
  cardHolderContainer
  ${hoverPointer ? "hoverPointer" : ""}
${leftHoverPointer && !isSidebarOpen ? "leftHoverPointer" : ""}
${leftHoverPointer && isSidebarOpen ? "sidebarHoverPointer" : ""}
`}
  
    style={{
      maxWidth: cardWidth,
      marginBottom: '0px',
      paddingBottom: '0px',
      // maxHeight: '300px'
    }}
  >
      <div className={(isHovered && source === 'exploreAll') ? "cardHolder cardHolderHovered" : "cardHolder"} 
        style={{
          marginBottom: '0px',
          paddingBottom: '0px',
        }}
      >
        <div className={(isHovered && source !== 'exploreAll') ? "cardHolderInner hovered" : "cardHolderInner"}   onMouseEnter={() => setIsHovered(true)}
    onMouseLeave={() => setIsHovered(false)}>
          <div
            className="cardHolderMedia noSelect">
            <div
              style={{
                ...getBackgroundStyle(carouselTitle),
                position: "relative",
              }}
              className="cardHolderMediaImageDiv"
              ref={wrapperRef}
            >
              {isHovered && coverVideoUrl && !purchased ? (
                <>
                  <video
                    ref={videoRef}
                    src={coverVideoUrl}
                    width="100%"
                    height="100%"
                    playsInline
                    loop
                    muted
                    poster={accelerator.image}
                    style={{ objectFit: "cover" }}
                    onClick={handleVideoClick}
                  />
                  {(!isClicked || isVideoMutted) && !isIOS() && (
                    <div
                      style={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        width: "148px",
                        transform: "translate(-50%, -50%)",
                        backgroundColor: "#18181BBF",
                        color: "white",
                        padding: "6px 13px 6px",
                        borderRadius: "20px",
                        cursor: "pointer",
                        fontSize: "14px",
                        zIndex: 2,
                      }}
                      onClick={handleVideoClick}
                    >
                      <div style={{ display: "inline-block", marginRight: "8px", position: "relative", bottom: "1px" }}>
                        <svg width="18" height="13" viewBox="0 0 18 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M11.5156 4.68933C12.1445 5.20886 12.5 5.89246 12.5 6.71277C12.5 7.50574 12.1445 8.24402 11.5156 8.73621C11.4062 8.81824 11.2422 8.87292 11.1055 8.87292C10.9141 8.87292 10.7227 8.79089 10.5859 8.62683C10.3672 8.35339 10.3945 7.94324 10.6953 7.69714C10.9961 7.45105 11.1875 7.09558 11.1875 6.71277C11.1875 6.32996 10.9961 5.97449 10.6953 5.72839C10.3945 5.4823 10.3672 5.07214 10.5859 4.79871C10.832 4.52527 11.2422 4.47058 11.5156 4.68933ZM13.1836 2.69324C14.4141 3.67761 15.125 5.12683 15.125 6.71277C15.125 8.27136 14.4141 9.74792 13.1836 10.7323C13.0469 10.8417 12.9102 10.8964 12.7461 10.8964C12.5547 10.8964 12.3906 10.8143 12.2539 10.6503C12.0078 10.3768 12.0625 9.96667 12.3359 9.72058C13.2656 8.95496 13.8125 7.83386 13.8125 6.71277C13.8125 5.56433 13.2656 4.44324 12.3359 3.70496C12.0625 3.45886 12.0078 3.04871 12.2539 2.77527C12.4727 2.50183 12.8828 2.44714 13.1836 2.69324ZM14.8516 0.642456C16.6836 2.14636 17.75 4.30652 17.75 6.71277C17.75 9.09167 16.6836 11.3065 14.8516 12.8104C14.7148 12.9198 14.5781 12.9471 14.4414 12.9471C14.25 12.9471 14.0586 12.8651 13.9219 12.701C13.7031 12.4276 13.7305 11.9901 14.0039 11.7714C15.5352 10.5135 16.4375 8.65417 16.4375 6.71277C16.4375 4.74402 15.5352 2.91199 14.0039 1.65417C13.7305 1.43542 13.7031 0.997925 13.9219 0.724487C14.168 0.45105 14.5781 0.423706 14.8516 0.642456ZM8.48047 0.6698C8.78125 0.833862 9 1.13464 9 1.49011V11.9628C9 12.3182 8.78125 12.619 8.48047 12.7557C8.34375 12.8104 8.23438 12.8378 8.125 12.8378C7.90625 12.8378 7.6875 12.7557 7.52344 12.619L3.83203 9.33777H1.5625C0.824219 9.33777 0.25 8.76355 0.25 8.02527V5.42761C0.25 4.68933 0.824219 4.11511 1.5625 4.11511H3.83203L7.52344 0.833862C7.79688 0.587769 8.15234 0.533081 8.48047 0.6698Z" fill="white"/>
                        </svg>
                      </div>
                      <span style={{ position: "relative", bottom: "1px" }}>Click For Sound</span>
                    </div>
                  )}

                  {!isVideoMutted && isHovered && !isIOS() && (
                    <div
                      style={{
                        position: "absolute",
                        top: "5px",
                        left: "5px",
                        zIndex: 2,
                      }}
                      onClick={handleVideoClick}
                    >
                      <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M0 16C0 7.16344 7.16344 0 16 0C24.8366 0 32 7.16344 32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16Z" fill="#18181B" fill-opacity="0.75"/>
                          <path d="M16.3555 9.70703C16.6562 9.84375 16.8477 10.1719 16.8477 10.5V20.9453C16.8477 21.2734 16.6562 21.6016 16.3555 21.7383C16.2188 21.793 16.1094 21.8203 16 21.8203C15.7812 21.8203 15.5625 21.7383 15.3984 21.6016L11.707 18.3203H9.4375C8.69922 18.3203 8.125 17.7461 8.125 17.0352V14.4375C8.125 13.7266 8.69922 13.125 9.4375 13.125H11.707L15.3984 9.87109C15.6719 9.625 16.0273 9.57031 16.3555 9.70703ZM22.1523 15.75L23.4375 17.0352C23.7109 17.3086 23.7109 17.7188 23.4375 17.9648C23.1914 18.2383 22.7812 18.2383 22.5352 17.9648L21.25 16.6797L19.9375 17.9648C19.6641 18.2383 19.2539 18.2383 19.0078 17.9648C18.7344 17.7188 18.7344 17.3086 19.0078 17.0352L20.293 15.75L19.0078 14.4648C18.7344 14.2188 18.7344 13.8086 19.0078 13.5352C19.2539 13.2891 19.6641 13.2891 19.9375 13.5352L21.25 14.8477L22.5078 13.5352C22.7812 13.2617 23.1914 13.2617 23.4375 13.5352C23.7109 13.7812 23.7109 14.1914 23.4375 14.4648L22.1523 15.75Z" fill="white"/>
                        </svg>
                    </div>
                  )}
                </>
              ) : (
                <Fragment>
                  <img
                    style={isProductType ? { objectFit: "contain" } : undefined}
                    className="cardHolderMediaImageDivImage"
                    src={accelerator.image}
                    alt={accelerator.name}
                  />
                </Fragment>
                
              )}
              {carouselTitle !== ProductType.Clubs && carouselTitle !== ProductType["Training Aids"] && <TooltipCustom
                slotProps={{
                  popper: {
                    sx: {
                      [`&.${tooltipClasses.popper}[data-popper-placement*="bottom"] .${tooltipClasses.tooltip}`]: {
                        marginTop: "6px",
                      },
                    },
                  },
                }}
                title={accelerator.progress + "%"}
              >
                <BorderLinearProgress
                  className="borderLinearProgress"
                  variant="determinate"
                  value={accelerator.progress}
                />
              </TooltipCustom>}
              {!purchased && !isHovered && (
                <div
                  style={{
                    backgroundColor: "rgba(0, 0, 0, 0.55)",
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "calc(100% - 11px)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    zIndex: 1,
                    borderRadius: "7px"
                  }}
                >
                  <div className="lockIconFrame">
                    <WhiteLockIcon />
                  </div>
                </div>
              )}
            </div>
          </div>
          <Box className="courseCardFullContent" onClick={(event) => {
            if (!isSmallScreen && !buttonisClicked) {
              if (!purchased) {
                handleSendClickCourseButtonMixPanelEvent({
                  source: 'Netflix',
                  carouselTitle,
                  status: 'Locked',
                  courseName: accelerator.name,
                  location: locationValue,
                  hasCpPopup: accelerator.hasCpPopup,
                  withTimeout: isProductType
                });
                openPopUp(event, accelerator.hasCpPopup, accelerator.url, accelerator.name, "Locked Course", accelerator.oneClickUrl);
              } else {
                handleSendClickCourseButtonMixPanelEvent({
                  source: 'Netflix',
                  carouselTitle,
                  status: isProductType ? 'Locked' : 'Owned',
                  courseName: accelerator.name,
                  location: locationValue,
                  hasCpPopup: false,
                  withTimeout: false
                });
                navigateToPage(carouselTitle === "Drills" && !orderByDocument.slice(0, 10).includes(accelerator.name) ? removeDomainFromUrl(accelerator.drill_redirect_url) : removeDomainFromUrl(accelerator.url));
              }
            }
          }
          }>
            <div className="courseCardContent">              
              <Indicators filters={accelerator.filters} isHovered={isHovered} />
              <Typography
                fontSize={{ xs: 14, md: 16 }}
                fontWeight={500}
                textAlign={"left"}
                lineHeight={{
                  xs: "14px",
                  md: "18px",
                }}
                className="cardCourseName"
              >
                {accelerator.name}
              </Typography>
              <Typography
                fontSize={{ xs: 14, md: 14 }}
                fontWeight={500}
                lineHeight={{ xs: "14px", md: "16px" }}
                marginLeft={{ xs: "auto" }}
                marginRight={{ xs: "auto" }}
                className={isHovered && coverVideoUrl && !purchased ? 'cardCourseDesc cardCourseNameVideo' : 'cardCourseDesc'}
                sx={{                  
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    display: '-webkit-box',
                    WebkitLineClamp: 2,
                    WebkitBoxOrient: 'vertical',
                    fontSize: isMobile && carouselTitle == 'Explore All' ? '14px !important' : '14px !important',
                }}
              >
                {accelerator.desc !== "" ? accelerator.desc?.replace(/<\/?p>/g, '') : ""}
              </Typography>
            </div>
            <div className="cardButton">
              <div className="cardButtonInner">
                <>
                  {!purchased ? (
                    <a
                      style={{ textDecoration: "none" }}
                    >
                      <Button
                        className={styles.unlockBtn}
                        fullWidth
                        onClick={(event) => {
                          buttonisClicked = true;
                          handleSendClickCourseButtonMixPanelEvent({
                            source: 'Netflix',
                            carouselTitle,
                            status: 'Locked',
                            courseName: accelerator.name,
                            location: locationValue,
                            hasCpPopup: accelerator.hasCpPopup,
                            withTimeout: isProductType
                          });
                          openPopUp(event, accelerator.hasCpPopup, accelerator.url, accelerator.name, "Locked Course", accelerator.oneClickUrl);
                        }}
                        onMouseEnter={() => setIsHoverdUnlockButton(true)}
                        onMouseLeave={() => setIsHoverdUnlockButton(false)}
                      >
                        <Typography
                          sx={{
                            fontSize: "16px",
                            fontWeight: 700,
                            whiteSpace: "nowrap",
                          }}
                        >
                         Unlock Course
                        </Typography>
                      </Button>
                    </a>
                  ) : (
                    <a
                      href={isProductType ?
                        accelerator.url :
                        (carouselTitle === "Drills" && !orderByDocument.slice(0, 10).includes(accelerator.name) ?
                          removeDomainFromUrl(accelerator.drill_redirect_url) :
                          removeDomainFromUrl(accelerator.url))
                      }
                      target={isProductType ? "_blank" : "_self"}
                      rel={isProductType ? "noopener noreferrer" : ""}
                      style={{ textDecoration: "none" }}
                      onClick={(e: React.MouseEvent<HTMLElement>) => {
                        if (isProductType) {
                          e.preventDefault();
                          window.open(createProductTypeUrl(accelerator.url), '_blank', 'noopener,noreferrer');
                        }
                      }}
                    >
                      <Button
                        className={isMostPopularSplitEnabled ? styles.continueBtnSplitTest : styles.continueBtn}
                        onClick={() => {
                          buttonisClicked = true;
                          handleSendClickCourseButtonMixPanelEvent({
                            source: 'Netflix',
                            carouselTitle,
                            status: isProductType ? 'Locked' : 'Owned',
                            courseName: accelerator.name,
                            location: locationValue,
                            hasCpPopup: false,
                            withTimeout: false
                          });
                        }}
                      >
                        <div className="continueBtnText">
                          {/*!isProductType && <PlayCircleFilledOutlinedIcon
                            className={styles.continueBtnIcon}
                            color="inherit"
                          />*/}
                          {isProductType ? (
                            <span style={{ marginLeft: "7px", fontSize: "16px" }}>
                              Learn More
                            </span>
                          ) : (
                            <span style={{ marginLeft: "7px", fontSize: "16px" }}>
                              {accelerator.progress === 0 ? "Begin Training" : "Continue Training"}
                            </span>
                          )}
                        </div>
                      </Button>
                    </a>
                  )}

                  <Button
                    className="closeBtn showForMobileFlex g10px"
                    onClick={(event) => {
                      event.stopPropagation();
                      setIsHovered(false);
                    }}
                  >
                    <Xclose />
                    <span>Close</span>
                  </Button>
                </>
              </div>
            </div>
          </Box>
        </div>
      </div>
    </div>
  );
}
